import { useCallback } from 'react';

import { useProducts } from 'contexts/Products';
import ProductSelectField from 'fields/ProductSelectField';
import { useField } from 'formik';

import type { IProductName } from './types';
import { APP_PRODUCT_TYPE } from 'appConstants';

export default function ProductName({ disabled }: IProductName) {
  const [, , { setValue }] = useField('productData');

  const {
    state,
    selectors: { selectProduct },
  } = useProducts();

  const handleChange = useCallback(
    (value) => {
      setValue(selectProduct(state, value) || {});
    },
    [state, selectProduct, setValue],
  );

  return (
    <ProductSelectField
      name="packagedItemReference"
      disabled={disabled}
      onChange={handleChange}
      productType={APP_PRODUCT_TYPE.CROP}
      textFieldProps={{
        required: true,
      }}
    />
  );
}
